import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import { InjectedConnector as OKExConnector } from "web3-react-okexchain-connector";
import { LedgerHQConnector } from "web3-ledgerhq-connector";
import { LedgerHQFrameConnector } from "web3-ledgerhq-frame-connector";
import { Coin98Connector } from "connectors/coin98connector";
import { SafePalConnector } from "connectors/safePalConnector";
import { MathWalletConnector } from "connectors/mathWalletConnector";
import { TrustWalletConnector } from "connectors/trustConnector";

// Config
import { rpcUrlMapping } from "config/network";
import { NetworkConfigType } from "config/network/types";
import { BitKeepWalletConnector } from "connectors/bitKeepConnector";
import { PhantomWalletConnector } from "connectors/phantomConnector";
import { ExodusWalletConnector } from "connectors/exodusConnector";

export const getLedgerLiveConnector = (supportedChainIds: number[]) => {
  let LedgerHQFrame: any = new LedgerHQFrameConnector();
  LedgerHQFrame.supportedChainIds = supportedChainIds;
  return LedgerHQFrame;
};

export const getInjectedConnector = (supportedChainIds: number[]) =>
  new InjectedConnector({
    supportedChainIds,
  });

export const getInjectedKuWallet = (supportedChainIds: number[]) =>
  new InjectedConnector({
    supportedChainIds,
  });

export const getWalletConnectConnector = (rpcUrls: any, chainId: number) =>
  new WalletConnectConnector({
    rpc: rpcUrls,
    chainId: chainId,
    bridge: "https://bridge.walletconnect.org",
    qrcode: true,
    clientMeta: {
      description: "Stake Matic with Stader",
      url: "https://polygon.staderlabs.com",
      icons: ["https://polygon.staderlabs.com/favicon-32x32.png"],
      name: "Polygon x Staderlabs",
    },
  });

export const getWalletLinkConnector = (
  rpcUrl: any,
  supportedChainIds: number[]
) =>
  new WalletLinkConnector({
    url: rpcUrl,
    appName: "Stader Labs",
    supportedChainIds: supportedChainIds,
  });

export const getOKExConnector = (supportedChainIds: number[]) =>
  new OKExConnector({
    supportedChainIds,
  });

export const getLedgerConnector = (chainId: number, rpcUrl: string) =>
  new LedgerHQConnector({
    chainId,
    url: rpcUrl,
  });

export const getCoin98Connector = (supportedChainIds: number[]) =>
  new Coin98Connector({
    supportedChainIds,
  });

export const getSafepalConnector = (supportedChainIds: number[]) =>
  new SafePalConnector({
    supportedChainIds,
  });

export const getMathWalletConnector = (supportedChainIds: number[]) =>
  new MathWalletConnector({
    supportedChainIds,
  });

export const getTrustWalletConnector = (supportedChainIds: number[]) =>
  new TrustWalletConnector({
    supportedChainIds,
  });

export const getBitKeepWalletConnector = (supportedChainIds: number[]) =>
  new BitKeepWalletConnector({
    supportedChainIds,
  });

export const getPhantomWalletConnector = (supportedChainIds: number[]) =>
  new PhantomWalletConnector({
    supportedChainIds,
  });

export const getExodusWalletConnector = (supportedChainIds: number[]) =>
  new ExodusWalletConnector({
    supportedChainIds,
  });

export const getConnector = (key: string, config: NetworkConfigType) => {
  const isPolygonChainActive = config.chainId === "0x89";

  const rpcUrl = isPolygonChainActive
    ? process.env.NEXT_PUBLIC_ALCHEMY_POLYGON_HTTPS_URL
    : process.env.NEXT_PUBLIC_ALCHEMY_HTTPS_URL;

  const rpcUrls: { [chainId: number]: string } =
    config.supportedChainIDs.reduce(
      (acc, curr) => ({ ...acc, [curr]: rpcUrlMapping[curr] }),
      {}
    );

  switch (key) {
    case "injected":
      return getInjectedConnector(config.supportedChainIDs);

    case "kuwallet":
      return getInjectedKuWallet(config.supportedChainIDs);

    case "walletConnect":
      return getWalletConnectConnector(rpcUrls, +config.chainId);

    case "coinbaseWallet":
      return getWalletLinkConnector(rpcUrl, config.supportedChainIDs);

    case "okex":
      return getOKExConnector(config.supportedChainIDs);

    case "ledger":
      return getLedgerConnector(+config.chainId, rpcUrl as string);

    case "ledgerLive":
      return getLedgerLiveConnector(config.supportedChainIDs);

    case "coin98":
      return getCoin98Connector(config.supportedChainIDs);

    case "safepal":
      return getSafepalConnector(config.supportedChainIDs);

    case "mathwallet":
      return getMathWalletConnector(config.supportedChainIDs);

    case "trustwallet":
      return getTrustWalletConnector(config.supportedChainIDs);

    case "bitkeep":
      return getBitKeepWalletConnector(config.supportedChainIDs);

    case "phantom":
      return getPhantomWalletConnector(config.supportedChainIDs);

    case "exodus":
      return getExodusWalletConnector(config.supportedChainIDs);

    default:
      return getInjectedConnector(config.supportedChainIDs);
  }
};

export const isZerion = (connectorKey: string) => {
  return (
    connectorKey === "injected" &&
    window.ethereum &&
    (window.ethereum as any).isZerion
  );
};
// export const activateInjectedProvider = (connector: any) => {
//   const { ethereum } = window;
//   console.log(ethereum);
//   console.log(connector);
//   if (!ethereum?.providers || !connector) {
//     return undefined;
//   }

//   let provider = undefined;
//   if (connector instanceof InjectedConnector) {
//     console.log("injected");
//     provider = ethereum.providers.find(({ isMetaMask }) => isMetaMask);
//   } else if (connector instanceof WalletLinkConnector) {
//     console.log("walletLink");
//     provider = ethereum.providers.find(
//       ({ isCoinbaseWallet }) => isCoinbaseWallet
//     );
//   }

//   console.log(provider);

//   if (provider && ethereum.setSelectedProvider) {
//     ethereum.setSelectedProvider(provider);
//   }
//   return provider;
// }
